export enum SignStatus {
  None = 0, // 未签约
  Signed = 3, // 已签约
  InvitedOrApplied = 4 // 有申请或者邀请记录
}

export interface signApplyInviteInfo {
  in_id: string;
  in_sender_type: string;
  in_type: string;
  owuid: string;
}

export interface AnchorSignStatus {
  contract?: string;
  code: SignStatus;
  msg?: string;
  applyList?: { [key: string]: signApplyInviteInfo };
  inviteList?: { [key: string]: signApplyInviteInfo };
}
